'use client'

import { widgetStore } from '@/domains/WebApp/store/Widget'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import styles from './WidgetSettings.module.scss'

export const WidgetSettings = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    const widget = searchParams.get('widget')
    if (widget != null) {
      widgetStore.setIsWidget(widget === 'true')

      document.body.classList.add(styles.widgetScrollbar)
    }
  }, [searchParams])

  return null
}
